import { render, staticRenderFns } from "./Editor_photo.vue?vue&type=template&id=4fdbf866"
import script from "./Editor_photo.vue?vue&type=script&lang=js"
export * from "./Editor_photo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports